
import UnifiedConnectWallet from './UnifiedConnectWallet';

interface ConnectWalletStepProps {
  onConnectWallet: () => void;
}

const ConnectWalletStep = ({ onConnectWallet }: ConnectWalletStepProps) => {
  return <UnifiedConnectWallet onConnectWallet={onConnectWallet} />;
};

export default ConnectWalletStep;
